import React, { createContext, useContext, useMemo } from "react";

import { TReportAdminScope } from "../reportCatalog.types";

interface IReportAutoRunContextValue {
  scope: TReportAdminScope;
  reportCode: string;
  isDedicatedRoute: boolean;
}

const ReportAutoRunContext = createContext<IReportAutoRunContextValue | null>(null);

interface IReportAutoRunProviderProps {
  scope: TReportAdminScope;
  reportCode: string;
  isDedicatedRoute: boolean;
  children: React.ReactNode;
}

export function ReportAutoRunProvider(props: IReportAutoRunProviderProps) {
  const { scope, reportCode, isDedicatedRoute, children } = props;

  const value = useMemo(
    () => ({
      scope,
      reportCode,
      isDedicatedRoute,
    }),
    [scope, reportCode, isDedicatedRoute],
  );

  return <ReportAutoRunContext.Provider value={value}>{children}</ReportAutoRunContext.Provider>;
}

export function useReportAutoRunContext(): IReportAutoRunContextValue | null {
  return useContext(ReportAutoRunContext);
}
